import { render, staticRenderFns } from "./Offensive.vue?vue&type=template&id=5b7c586d&scoped=true&"
import script from "./Offensive.vue?vue&type=script&lang=js&"
export * from "./Offensive.vue?vue&type=script&lang=js&"
import style0 from "./Offensive.vue?vue&type=style&index=0&id=5b7c586d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c586d",
  null
  
)

export default component.exports